module.exports = __webpack_public_path__ + "img/p4.f0df08e1.png";